import { render, staticRenderFns } from "./DataViewSidebarTasks.vue?vue&type=template&id=5574ab9e&scoped=true&"
import script from "./DataViewSidebarTasks.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarTasks.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarTasks.vue?vue&type=style&index=0&id=5574ab9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574ab9e",
  null
  
)

export default component.exports